<script src="https://static.line-scdn.net/liff/edge/2/sdk.js"></script>
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
<template>
  <v-container>
    <v-layout text-center wrap>
      <span id="main_title">
        <span id="main_title_text">
          <h4>会員情報</h4>
        </span>
      </span>
      <span id="header_logo"
        ><img src="https://misemeg.jp/appli/img/misemeg-logo.svg" width="45px"
      /></span>
      <span id="window_close" @click="returntop"
        ><i class="fa fa-angle-double-left fa-3x fa-fw" title="TOP画面に戻る"></i
      ></span>
      <v-flex xs12>
        <br />
        <hr />
        <br />
        会員証名： {{ this.$_shopname() }}
        <br />
        <br />
        メール： {{ email }}
        <br />
        <br />
        <table style="margin-left: auto; margin-right: auto">
          <tr>
            <td><img id="line_profile_img" style="width: 45px; height: 45px" /></td>
            <td>&emsp; {{ name }}</td>
          </tr>
        </table>
        <br />
        <br />
        <hr />
        <br />
        <span id="main_caption">
          以下のメニューから、ユーザー情報の変更や会員証の削除が行えます。<br />※メールアドレスの変更は、<br />LINEホーム画面のアカウントから設定してください。
        </span>
        <br />
        <br />
        <v-flex mb-4 xs12 id="area_user_information">
          <div class="ma-4">
            <span id="user_information" @click="user_information">会員情報編集</span>
          </div>
        </v-flex>
        <br />
        <v-flex mb-4 xs12 id="area_delete_memcard">
          <div class="ma-4">
            <span id="delete_memcard" @click="delete_memcard">会員証の削除</span>
          </div>
        </v-flex>
        <span id="delete_msg" hidden></span>
        <v-flex mb-4 xs12>
          <div class="ma-4">
            <!-- <v-btn large color="success" @click="storeslist" title="店舗一覧情報を表示します" id="storeslist_btn">店舗一覧</v-btn> -->
            <span
              id="user_maintenance"
              @click="user_maintenance_ss"
              style="font-size: x-small"
              >ユーザー情報のメンテナンス</span
            >
          </div>
        </v-flex>
        <span id="misemeg_uid"></span>
        <br />
        <v-flex mb-4 xs12 id="area_create_shortcut">
          <div class="ma-4">
            <span id="create_shortcut" @click="create_shortcut"
              >ホーム画面に追加<br />（※最新ＯＳのみ対応）</span
            >
          </div>
        </v-flex>
        <br />
        <br />
        <hr />
        <span class="app_info">
          <br />
          LINEミニアプリ
          <br />
          <a
            href="https://www.busicom.co.jp/product/misemeg/mini/?openExternalBrowser=1"
            target="_blank"
            >みせめぐMini</a
          >
          <br />
          version 2.5.0.1
          <br />
          リリース日：2024/12/02
          <br />
          <br />
          <hr />
          <br />
          <a href="https://www.busicom.co.jp/" target="_blank"
            >運営・開発元：株式会社ビジコム<br />みせめぐ運営事務局・開発部</a
          >
          <br />
          <br />
          <a href="https://misemeg.jp/appli/privacypolicy.html" target="_blank"
            >プライバシーポリシー</a
          >
          <br />
          <br />
          <a href="https://misemeg.jp/appli/terms.html" target="_blank"
            >みせめぐアプリ利用規約</a
          >
          <br />
          <br />
          Copyright &copy; BUSICOM.Co.,ltd.
          <br />
        </span>
        <span id="member_info" hidden></span>
      </v-flex>
      <br />
      <br />
      <!-- Snackbar -->
      <div>
        <v-snackbar
          v-model="snackbarFlag"
          color="primary"
          multi-line
          :timeout="snackbarTimeout"
          top
        >
          {{ snackbarText }}
        </v-snackbar>
      </div>
      <br />
      <br />
      <!-- <v-flex mb-4 xs12>
        <br /><br />
        <div class="ma-4">
          <span id="copyright"><a href="https://www.busicom.co.jp/product/misemeg/mini/?openExternalBrowser=1"
              target="_blank">&emsp;みせめぐ&nbsp;&times;&nbsp;LINEミニアプリ&emsp;<br />&emsp;Copyright &copy; BUSICOM.Co.,ltd.
            </a><br />&emsp;v2.5.0.1&emsp;</span>
        </div>
      </v-flex> -->
    </v-layout>
  </v-container>
</template>
<style>
.v-main {
  background-color: #f3f3f3;
  text-align: center;
}
#main_caption {
  color: #222;
  font-size: small;
}
#recomendation_tbl {
  display: fixed;
  margin: 0 auto;
  width: 100%;
  border-collapse: collapse;
  border: 0px solid #000;
  background-color: #f3f3f3;
}
#recomendation_tbl td {
  border-collapse: collapse;
  border: 0px solid #000;
  text-align: left;
  min-width: 100px;
}
#main_title {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #00843f;
  color: #ddd;
  width: 100%;
  height: 70px;
  letter-spacing: 0.3em;
  margin-top: -12px;
  margin-left: -12px;
  margin-right: -50px;
}
#main_title_text {
  text-align: center;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.3em;
  margin-top: 0px;
  margin-left: -10px;
  margin-right: 0px;
}
#header_logo {
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -70px;
  margin-left: 0px;
  margin-right: 100px;
}
#returntop_btn {
  width: 50%;
  font-size: large;
}
#window_close {
  margin-top: -58px;
  padding-left: 84%;
  color: #f3f3f3;
}

#area_user_information {
  text-align: center;
}
#user_information {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  width: 60%;
  text-align: center;
  font-size: small;
  color: #fff;
  background: #c0c0c0;
  border: 1px solid #c0c0c0;
  border-radius: 5px;
  padding: 5px;
  letter-spacing: 0.5em;
  text-decoration: none;
}
#area_user_maintenance {
  text-align: center;
}
#user_maintenance {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  width: 60%;
  text-align: center;
  font-size: small;
  color: #c0c0c0;
  /*
   background:#c0c0c0;
   border:1px solid #c0c0c0;
   */
  border-radius: 5px;
  padding: 5px;
  letter-spacing: 0.1em;
  text-decoration: underline;
}
#area_line_logout {
  text-align: center;
}
#line_logout {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  width: 60%;
  text-align: center;
  font-size: small;
  color: #fff;
  background: #c0c0c0;
  border: 1px solid #c0c0c0;
  border-radius: 5px;
  padding: 5px;
  letter-spacing: 0.5em;
  text-decoration: none;
}
#area_delete_memcard {
  text-align: center;
}
#delete_memcard {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  width: 60%;
  text-align: center;
  font-size: small;
  color: #fff;
  background: #c0c0c0;
  border: 1px solid #c0c0c0;
  border-radius: 5px;
  padding: 5px;
  letter-spacing: 0.5em;
  text-decoration: none;
}
#create_shortcut {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  width: 60%;
  text-align: center;
  font-size: small;
  color: #fff;
  background: #c0c0c0;
  border: 1px solid #c0c0c0;
  border-radius: 5px;
  padding: 5px;
  letter-spacing: 0.5em;
  text-decoration: none;
}

.std_row {
  background-color: #f3f3f3;
}

.alt_row {
  background-color: #f3f3f3;
}

.data_img {
  text-align: center;
  margin: 0 auto;
}

#copyright {
  margin: 0 auto;
  color: #88b3b3;
  text-decoration: none;
}

#copyright a {
  margin: 0 auto;
  color: #88b3b3;
  text-decoration: none;
}

#misemeg_uid {
  font-size: small;
  margin: 0 auto;
  color: #c0c0c0;
  text-decoration: none;
}

#row_sales_price td {
  text-align: center;
}

#delete_msg {
  height: 5%;
  padding: 10px;
  font-weight: bold;
  background: #cce782;
  color: #000;
}

hr {
  height: 3px;
  border: 0;
  border-color: #222;
  box-shadow: inset 0 12px 12px -12px rgba(168, 168, 168, 0.7);
}

.app_info {
  font-size: small;
  color: #222;
  text-decoration: none;
}
</style>
<script>
// for encrypt message
import crypto from "crypto-js";
var CryptoJS = require("crypto-js");
// var dts = new Date().getDate();
var dts = "651127";
var passPhrase =
  "45b54c392cc235a79ce573f623b2f8023" + dts + "d6dd6edf2488805962a3d223be6566b";
const salt = CryptoJS.lib.WordArray.random(128 / 8);
const iv = CryptoJS.lib.WordArray.random(128 / 8);
const key = "0921b90b3b7dab492b4aa897e3d0ccffde0f59579fc0c6229213c" + dts + "94822466ce8";

// for HTTP response
import axios from "axios";

export default {
  data() {
    return {
      snackbarFlag: false,
      snackbarTimeout: 3000,
      snackbarText: "",
      name: "",
      imgURL: "",
      userId: "",
      email: "",
      barcode_url: "",
      inClient: false,
    };
  },
  created() {
    this.initializeLiff();
    //window.alert('page loaded');
  },
  mounted() {
    $("#main_title").css("width", window.outerWidth);
    //"みせめぐMini"試験環境起動アイコン作成用コマンド
    // liff.createShortcutOnHomeScreen({
    //     url:"https://miniapp.line.me/1660679485-o2JvvaOG",
    // }).then(() => { /* ... */ });
  },
  methods: {
    initializeLiff: function () {
      var me = this;
      liff.init(
        {
          liffId: process.env.VUE_APP_LIFF_ID,
        },
        (data) => {
          me.loginCheck();
        },
        (err) => {
          console.log("LIFF initialization failed", err);
        }
      );
    },
    loginCheck: function () {
      var me = this;
      // 0016891 20240918 "liff init failure"エラーの対策で liff.ready の処理を追記
      liff.ready.then(() => {
        // ログインチェック
        if (liff.isLoggedIn()) {
          this.isClient = liff.isInClient();
          const permissionStatus = liff.permission.query("email");
          debugger;
          if (permissionStatus.state === "prompt") {
            liff.permission.requestAll();
          }

          //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
          var miseid = this.$_t_shopid();
          //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
          var debug_mode = this.$_debug_mode();
          if (debug_mode == "2") {
            miseid = this.$_shopid();
          }
          var encrypted_myshopid = localStorage.getItem("lmmini_" + dts + "_myshopid");
          if (encrypted_myshopid) {
            const dec_encrypted_myshopid = CryptoJS.AES.decrypt(encrypted_myshopid, key, {
              iv: iv,
            });
            miseid = dec_encrypted_myshopid.toString(CryptoJS.enc.Utf8);
          }

          const idToken = liff.getDecodedIDToken();
          console.log(idToken); // print decoded idToken object
          //idToken からメールが取得出来ない場合はlocalStorageに保存したメルアド情報を取得する
          var email_address = idToken.email;
          if (
            email_address == "undefined" ||
            email_address == null ||
            email_address == ""
          ) {
            //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
            var miseid = this.$_t_shopid();
            //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
            if (debug_mode == "2") {
              miseid = this.$_shopid();
            }
            var encrypted_mail = localStorage.getItem("lmmini_" + dts + "_maddr");
            var dec_email = CryptoJS.AES.decrypt(encrypted_mail, key, { iv: iv });
            email_address = dec_email.toString(CryptoJS.enc.Utf8);
          }
          // window.alert('email:' + email);

          // プロフィール取得
          liff
            .getProfile()
            .then((profile) => {
              me.name = profile.displayName;
              me.imgURL = profile.pictureUrl;
              me.userId = profile.userId;
              me.email = email_address;
              //me.barcode_img = barcode_url
              //debugger;
              //window.alert(me.imgURL);
              // プロフィール画像表示
              $("#line_profile_img").prop("src", me.imgURL);
            })
            .catch((err) => {
              console.log("error", err);
            });

          // md5()実行用ライブラリ読込
          var md5 = require("md5");
          // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく(午前ゼロ時をまたいでエラーになるケースはいったん無視する）
          var dt = new Date();
          var year = dt.getFullYear();
          var month = dt.getMonth() + 1;
          var strMonth = "";
          if (month < 10) {
            strMonth = "0" + month;
          } else {
            strMonth = month.toString();
          }
          var date = dt.getDate();
          var strDate = "";
          if (date < 10) {
            strDate = "0" + date;
          } else {
            strDate = date.toString();
          }
          var mmddyyyy = strMonth + "-" + strDate + "-" + year;

          //----------------------------
          // 位置情報の取得
          //----------------------------
          var tmp_lat = this.$_shoplat();
          var tmp_lng = this.$_shoplng();
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              function (position) {
                let coords = position.coords;
                tmp_lat = coords.latitude;
                tmp_lng = coords.longitude;
              }.bind(this),
              function (error) {
                // エラー処理を書く
              }
            );
          } else {
            // エラー処理を書く
          }
          if (isNaN(tmp_lat)) {
            tmp_lat = this.$_shoplat();
          }
          if (isNaN(tmp_lng)) {
            tmp_lng = this.$_shoplng();
          }

          //----------------------------
          // みせめぐユーザーIDの取得と表示
          //----------------------------
          this.getMisemegUID(email_address);
        } else {
          // ログインまだ
          this.$router.push({ name: "home" });
        }
      }); // end of liff.ready.then
    },
    logout: function () {
      // ログアウト
      if (liff.isLoggedIn()) {
        liff.logout();
        this.$router.push({ name: "home" });
      }
    },
    returntop: function () {
      if (liff.isLoggedIn()) {
        // line-mini トップ画面に戻る
        this.$router.push({ name: "login" });
      }
    },
    sendLINE: function () {
      var me = this;
      // LINEに送る
      liff
        .sendMessages([
          {
            type: "text",
            text: "あなたのアイコン画像を送ります",
          },
          {
            type: "image",
            originalContentUrl: me.imgURL,
            previewImageUrl: me.imgURL,
          },
        ])
        .then(() => {
          console.log("message sent");
          me.showSnackbar("LINEに送信しました");

          // 自動的に閉じるemail
          //setTimeout(()=> {
          //  liff.closeWindow()
          //},
          //  this.snackbarTimeout
          //)
        })
        .catch((err) => {
          console.log("error", err);
          me.showSnackbar("LINEに送信失敗しました");
        });
    },
    user_information: function () {
      // アプリの会員情報編集画面を表示
      var me = this;
      // 店舗ID
      //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
      var miseid = this.$_t_shopid();
      //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
      var debug_mode = this.$_debug_mode();
      if (debug_mode == "2") {
        miseid = this.$_shopid();
      }
      if (!miseid) {
        var encrypted_myshopid = localStorage.getItem("lmmini_" + dts + "_myshopid");
        if (encrypted_myshopid) {
          const dec_encrypted_myshopid = CryptoJS.AES.decrypt(encrypted_myshopid, key, {
            iv: iv,
          });
          miseid = dec_encrypted_myshopid.toString(CryptoJS.enc.Utf8);
        }
      }
      var enc64_sid = btoa(miseid);
      // window.alert('enc64_sid = ' + enc64_sid);
      //メルアドを取得してBase64エンコードする
      var mail_addr = this.email;
      //メルアドが取得できない場合はlocalStorageから取得する
      if (!mail_addr) {
        var encrypted_email = localStorage.getItem("lmmini_" + dts + "_maddr");
        const dec_encrypted_email = CryptoJS.AES.decrypt(encrypted_email, key, {
          iv: iv,
        });
        mail_addr = dec_encrypted_email.toString(CryptoJS.enc.Utf8);
      }
      var enc64_mail = btoa(mail_addr);
      //みせめぐUserIDをhidden領域から取得してBase64エンコードする
      var muid = document.getElementById("misemeg_uid").innerHTML;
      if (muid == "undefined" || muid == null || muid == "") {
        this.getMisemegUID(mail_addr);
      }
      var enc64_misemeg_uid = btoa(muid);
      //パスワード ※LINE連携以外のログインは使用しない前提で固定文字列'misemegpwd'とする
      var enc64_pwd = btoa("misemegpwd");
      //端末モード（9固定・ミニアプリ新設定義 emode=9）
      var emode = "9";
      //みせめぐ登録用WebAPIのURL設定(REST)
      // 0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
      var i_shopid = Number(this.$_shopid());
      var ext_server = "https://test.misemegu.jp/";
      // debug_mode=2（本番運用環境）でない場合はSTG環境とする
      if (debug_mode == "0") {
        ext_server = "http://localhost/mg/";
      }
      if (debug_mode == "2") {
        ext_server = "https://misemeg.jp/";
        if (i_shopid % 2 == 0) {
          ext_server = "https://sv2.misemeg.jp/";
        } else {
          ext_server = "https://sv1.misemeg.jp/";
        }
      } else {
        ext_server = "https://test.misemegu.jp/";
        if (i_shopid % 2 == 0) {
          ext_server = "https://sv2.misemegu.jp/";
        } else {
          ext_server = "https://sv1.misemegu.jp/";
        }
      }
      // for PC debug
      // ext_server = 'http://localhost/mg/';
      // var url = ext_server + "direct_url/api/member/////regist/" + enc64_mail + "//" + enc64_misemeg_uid + "//" + emode;
      var url =
        ext_server +
        "direct_url/api/member/////regist/" +
        enc64_mail +
        "/" +
        enc64_sid +
        "/" +
        enc64_misemeg_uid +
        "//" +
        emode;
      // window.alert('url = ' + url);
      var win_m = window.open(
        url,
        "_blank",
        "scrollbars=no,status=no,toolbar=no,location=no,menubar=no,resizable=yes,"
      );
      debugger;
    },
    user_maintenance: function () {
      if (window.confirm("ミニアプリのユーザー情報をクリアしてもよろしいですか？")) {
        //20230926 lmmini_で始まるキーを持った全項目を削除するように修正。
        for (var i = 0; i < localStorage.length; i++) {
          var key = localStorage.key(i);
          if (key.indexOf("lmmini_") > -1) {
            // if (key.indexOf('lmmini_') > -1 || key.indexOf('LIFF_STORE') > -1){
            localStorage.removeItem(key);
          }
        }
        window.alert(
          "自動で再起動しない場合は画面右上の「×」を押してミニアプリを終了後もう一度起動してください"
        );
        this.$router.push({ name: "home" });
      }
    },
    user_maintenance_s: function () {
      // ユーザー情報クリア
      //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
      var miseid = this.$_t_shopid();
      //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
      var debug_mode = this.$_debug_mode();
      if (debug_mode == "2") {
        miseid = this.$_shopid();
      }
      localStorage.removeItem("lmmini_" + dts + "_memcode");
      localStorage.removeItem("lmmini_" + dts + "_maddr");
      localStorage.removeItem("lmmini_" + dts + "_muid");
      localStorage.removeItem("lmmini_" + dts + "_myshopid");
      var encrypted_myshopid = localStorage.getItem("lmmini_" + dts + "_myshopid");
      if (encrypted_myshopid) {
        const dec_encrypted_myshopid = CryptoJS.AES.decrypt(encrypted_myshopid, key, {
          iv: iv,
        });
        var myshopid = dec_encrypted_myshopid.toString(CryptoJS.enc.Utf8);
        if (myshopid) {
          localStorage.removeItem("lmmini_" + myshopid + "_memcode");
          localStorage.removeItem("lmmini_" + myshopid + "_maddr");
          localStorage.removeItem("lmmini_" + myshopid + "_muid");
          localStorage.removeItem("lmmini_" + myshopid + "_myshopid");
        }
      }
    },
    user_maintenance_ss: function () {
      if (
        window.confirm(
          "ミニアプリ内部のみせめぐ会員証情報を削除するための機能です。\n「会員証の削除」押下後に、会員証発行画面に遷移しない場合のみ実行してください。\n内部情報を削除してもよろしいですか？"
        )
      ) {
        // ユーザー情報クリア
        //20230926 lmmini_で始まるキーを持った全項目を削除するように修正。
        for (var i = 0; i < localStorage.length; i++) {
          var key = localStorage.key(i);
          if (key.indexOf("lmmini_") > -1) {
            localStorage.removeItem(key);
          }
          if (key.indexOf("LIFF_STORE") > -1) {
            localStorage.removeItem(key);
          }
        }
        if (liff.isLoggedIn()) {
          liff.logout();
          liff.closeWindow();
          this.$router.push({ name: "home" });
        }
      }
    },
    delete_memcard: function () {
      if (
        window.confirm(
          "登録したデジタル会員証を削除します。\n購入履歴も確認することができなくなります。\n本当に削除しますか？"
        )
      ) {
        // アプリの会員情報編集画面を表示
        var me = this;
        // 店舗ID
        //店舗IDをグローバル変数から取得する（※初期値は試験用店舗コード）
        var miseid = this.$_t_shopid();
        //デバッグモード=2（本番用）の場合のみ本番用店舗コードで置換する 0015080
        var debug_mode = this.$_debug_mode();
        if (debug_mode == "2") {
          miseid = this.$_shopid();
        }
        var encrypted_myshopid = localStorage.getItem("lmmini_" + dts + "_myshopid");
        if (encrypted_myshopid) {
          const dec_encrypted_myshopid = CryptoJS.AES.decrypt(encrypted_myshopid, key, {
            iv: iv,
          });
          miseid = dec_encrypted_myshopid.toString(CryptoJS.enc.Utf8);
        }
        var enc64_sid = btoa(miseid);
        //メルアドを取得してBase64エンコードする
        var mail_addr = this.email;
        //メルアドが取得できない場合はlocalStorageから取得する
        if (!mail_addr) {
          var encrypted_email = localStorage.getItem("lmmini_" + dts + "_maddr");
          const dec_encrypted_email = CryptoJS.AES.decrypt(encrypted_email, key, {
            iv: iv,
          });
          mail_addr = dec_encrypted_email.toString(CryptoJS.enc.Utf8);
        }
        var enc64_mail = btoa(mail_addr);
        //みせめぐUserIDをhidden領域から取得してBase64エンコードする
        var muid = document.getElementById("misemeg_uid").innerHTML;
        // window.alert('muid = ' + muid);
        if (muid == "undefined" || muid == null || muid == "") {
          this.getMisemegUID(mail_addr);
        }
        // window.alert('muid = ' + muid);
        var enc64_misemeg_uid = btoa(muid);
        //パスワード ※LINE連携以外のログインは使用しない前提で固定文字列'misemegpwd'とする
        var enc64_pwd = btoa("misemegpwd");
        //端末モード（1固定=Android端末と同義）
        var emode = "1";
        //カードグループID（固定値）
        //グループIDをグローバル変数から取得する（※初期値は試験用）
        var mcgrpno = this.$_t_mcgrp();
        //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
        if (debug_mode == "2") {
          mcgrpno = this.$_mcgrp();
        }
        var enc64_mcgrpno = btoa(mcgrpno);
        //みせめぐオーナーID（固定値）
        //オーナーIDをグローバル変数から取得する（※初期値は試験用）
        var prmid = this.$_t_prmid();
        //デバッグモード=2（本番用）の場合のみ本番用変数で置換する 0015080
        if (debug_mode == "2") {
          prmid = this.$_prmid();
        }
        // window.alert('prmid = ' + prmid);
        var enc64_prmid = btoa(prmid);

        //会員証削除用 WebAPI(PHP) のURL設定
        // md5()実行用ライブラリ読込
        var md5 = require("md5");
        // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく
        var dt = new Date();
        var year = dt.getFullYear();
        var month = dt.getMonth() + 1;
        var strMonth = "";
        if (month < 10) {
          strMonth = "0" + month;
        } else {
          strMonth = month.toString();
        }
        var date = dt.getDate();
        var strDate = "";
        if (date < 10) {
          strDate = "0" + date;
        } else {
          strDate = date.toString();
        }
        var mmddyyyy = strMonth + "-" + strDate + "-" + year;

        var delete_card_url = "";
        //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
        var i_shopid = Number(this.$_shopid());
        if (debug_mode == "0") {
          delete_card_url = this.$_debug_url();
        } else if (debug_mode == "2") {
          if (i_shopid % 2 == 0) {
            delete_card_url = "https://sv2.misemeg.jp/";
          } else {
            delete_card_url = "https://sv1.misemeg.jp/";
          }
        } else {
          if (i_shopid % 2 == 0) {
            delete_card_url = "https://sv2.misemegu.jp/";
          } else {
            delete_card_url = "https://sv1.misemegu.jp/";
          }
        }
        // for PC debug ----------------
        // delete_card_url = this.$_debug_url();
        // -----------------------------
        delete_card_url += "appli/line/";
        delete_card_url += "deleteMemberCard.php?mail=";
        delete_card_url += enc64_mail;
        delete_card_url +=
          "&security=" +
          md5(
            mail_addr +
              "5ca968c5c9c793ad75b49ac19b493ad2misemeg" +
              mail_addr +
              "!Busicom04510" +
              mmddyyyy
          );
        delete_card_url += "&muid=" + enc64_misemeg_uid;
        delete_card_url += "&mcgrono=" + enc64_mcgrpno;
        delete_card_url += "&sid=" + enc64_sid;
        delete_card_url += "&prmid=" + enc64_prmid;
        // for debug
        // window.alert('delete_card_url = ' + delete_card_url);
        axios
          .get(delete_card_url)
          .then(
            (response) =>
              (document.getElementById("delete_msg").innerHTML = response.data)
          )
          // .then((response) => response.data)
          .catch((error) => console.log(error));
        $("#delete_msg").show();
      }
    },
    getMisemegUID: function (mail_addr) {
      // メルアドに対応するみせめぐユーザーIDを取得して misemeg_uid に設定する
      var getuid_url = "";
      var debug_mode = this.$_debug_mode();
      //0017124: 【みせめぐ】ミニアプリ内部からキックするDB照会用PHPのFQDNを顧客別にWeb1/Web2固定にする
      var i_shopid = Number(this.$_shopid());
      if (debug_mode == "0") {
        getuid_url = this.$_debug_url();
      } else if (debug_mode == "2") {
        if (i_shopid % 2 == 0) {
          getuid_url = "https://sv2.misemeg.jp/";
        } else {
          getuid_url = "https://sv1.misemeg.jp/";
        }
      } else {
        if (i_shopid % 2 == 0) {
          getuid_url = "https://sv2.misemegu.jp/";
        } else {
          getuid_url = "https://sv1.misemegu.jp/";
        }
      }
      // md5()実行用ライブラリ読込
      var md5 = require("md5");
      // tokenを当日のみ有効（最大24時間）とするため日付を求めてmmddyyyyにしておく
      var dt = new Date();
      var year = dt.getFullYear();
      var month = dt.getMonth() + 1;
      var strMonth = "";
      if (month < 10) {
        strMonth = "0" + month;
      } else {
        strMonth = month.toString();
      }
      var date = dt.getDate();
      var strDate = "";
      if (date < 10) {
        strDate = "0" + date;
      } else {
        strDate = date.toString();
      }
      var mmddyyyy = strMonth + "-" + strDate + "-" + year;
      getuid_url += "appli/line/";
      getuid_url += "getMisemegUID.php?mail=";
      getuid_url += mail_addr;
      getuid_url +=
        "&security=" +
        md5(
          mail_addr +
            "5ca968c5c9c793ad75b49ac19b493ad2misemeg" +
            mail_addr +
            "!Busicom04510" +
            mmddyyyy
        );
      // window.alert('getuid_url = ' + getuid_url);
      axios
        .get(getuid_url)
        .then(
          (response) => (document.getElementById("misemeg_uid").innerHTML = response.data)
        )
        .catch((error) => console.log(error));
    },
    showSnackbar(text) {
      this.snackbarFlag = true;
      this.snackbarText = text;
      setTimeout(() => {
        this.snackbarFlag = false;
        this.snackbarText = "";
      }, this.snackbarTimeout);
    },
    getBarcodeParam() {
      md5();
    },
    create_shortcut() {
      window.alert(
        "ホーム画面にミニアプリのアイコンを追加します（※本機能はLINE社試験中の新機能のため正常動作しない場合があります）"
      );
      //「ホーム画面に追加」ボタン押下時の処理
      var debug_mode = this.$_debug_mode();
      var user_ext_url = "";
      if (debug_mode == "2") {
        liff
          .createShortcutOnHomeScreen({
            url: `https://miniapp.line.me/1660679486-ezA66NjQ`,
          })
          .then(() => {
            window.alert("スマホのホーム画面にミニアプリのアイコンを追加しました");
          })
          .catch((err) => {
            window.alert(
              "スマホのホーム画面にミニアプリのアイコンを追加する際にエラーが発生しました"
            );
            console.log("error", err);
          });
      } else {
        //"みせめぐMini"試験環境起動アイコン作成用コマンド
        liff
          .createShortcutOnHomeScreen({
            url: `https://miniapp.line.me/1660679485-o2JvvaOG`,
          })
          .then(() => {
            window.alert("スマホのホーム画面にミニアプリのアイコンを追加しました");
          })
          .catch((err) => {
            window.alert(
              "スマホのホーム画面にミニアプリのアイコンを追加する際にエラーが発生しました"
            );
            console.log("error", err);
          });
      }
    },
  },
};
</script>
